type OptionsCommon = {
  providerConfigKey: string
}

type ResponseCommon = {
  type: 'nango'
  providerConfigKey: string
}

export const NangoCommon = (options: OptionsCommon): ResponseCommon => {
  return {
    type: 'nango',
    providerConfigKey: options.providerConfigKey,
  }
}

export type NangoCommonType = ReturnType<typeof NangoCommon>
